<script>
import Paging from "@/components/Paging.vue";
import Api from "api-client";

export default {
  name: "Cashregisters",
  components: {Paging},

  data() {
    return {
      result: {},
      searchTerm: "",
      expandedItemId: null,
      navPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés megtalálható</div></div><div><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés hiányzik</div></div>',
      dpPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl megtalálható</div></div><div><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl hiányzik</div></div>',
    }
  },
  props: {
    companyId: {
      required: true,
      type: Number,
    }
  },

  computed: {
    hasCompanyId() {
      return this.companyId !== null && this.companyId !== undefined;
    }
  },

  methods: {
    doPage(data) {
      this.loadData(data.pagingPage - 1, data.pagingOffset);
    },

    loadData(page, size) {
      Api.getCashRegisters(
          page,
          size,
          this.companyId,
          this.searchTerm
      )
          .then((resp) => (this.result = resp.data))
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    formatAmount(amount, currency) {
      if (amount === null || amount === undefined) {
        return '0 Ft';
      }
      const formattedAmount = amount.toLocaleString('hu-HU');
      const currencySymbol = currency || 'Ft';
      return `${formattedAmount} ${currencySymbol}`;
    },

    getIdoszakiOsszesForgalom(item) {
      // Priority: overrideDetails > navDetails > dpDetails
      if (item.overrideDetails && item.overrideDetails.idoszakiOsszesForgalom !== null) {
        return item.overrideDetails.idoszakiOsszesForgalom;
      }
      if (item.navDetails && item.navDetails.idoszakiOsszesForgalom !== null) {
        return item.navDetails.idoszakiOsszesForgalom;
      }
      if (item.dpDetails && item.dpDetails.idoszakiOsszesForgalom !== null) {
        return item.dpDetails.idoszakiOsszesForgalom;
      }
      return null;
    },

    getGongyolitettForgalom(item) {
      // Priority: overrideDetails > navDetails > dpDetails
      if (item.overrideDetails && item.overrideDetails.gongyolitettForgalom !== null) {
        return item.overrideDetails.gongyolitettForgalom;
      }
      if (item.navDetails && item.navDetails.gongyolitettForgalom !== null) {
        return item.navDetails.gongyolitettForgalom;
      }
      if (item.dpDetails && item.dpDetails.gongyolitettForgalom !== null) {
        return item.dpDetails.gongyolitettForgalom;
      }
      return null;
    },

    // Get the details source for displaying gross values
    getDisplayDetails(item) {
      // Priority: overrideDetails > navDetails > dpDetails
      if (item.overrideDetails) {
        return { source: 'override', details: item.overrideDetails };
      }
      if (item.navDetails) {
        return { source: 'nav', details: item.navDetails };
      }
      if (item.dpDetails) {
        return { source: 'dp', details: item.dpDetails };
      }
      return null;
    },

    // Check if we should show hasDifference warning (only when navDetails is null and dpDetails exists)
    shouldShowDifferenceWarning(item) {
      return !item.navDetails && item.dpDetails && item.hasDifference;
    },

    formatDate(dateString) {
      if (!dateString) {
        return '-';
      }
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}.${month}.${day}.`;
    },

    toggleExpanded(id) {
      // If clicking the same item, close it; otherwise open the new one and close the previous
      this.expandedItemId = this.expandedItemId === id ? null : id;
    },

    isExpanded(id) {
      return this.expandedItemId === id;
    },
  },

  watch: {
    searchTerm() {
      if (this.hasCompanyId) {
        this.loadData(0, 10);
      }
    },
    companyId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadData(0, 10);
        }
      }
    }
  },

  mounted() {
    if (this.hasCompanyId) {
      this.loadData(0, 10);
    }
  },
}
</script>

<template>
  <div class="Cashregisters_vue main-wrapper m-0 p-0 mt-3 font-jumperlight container-fluid">

<!--    <pre>-->
<!--    {{ result }}-->
<!--    </pre>-->

    <div class="mx-3 mt-2 mb-3">
      <b-form-input
          debounce="600"
          v-model="searchTerm"
          class="white-input d-inline-block align-middle"
          placeholder="Pénztárgép azonosító"
      ></b-form-input>
    </div>

    <div v-if="result && result.totalNumberOfElements === 0" class="mx-3">
      Nincsenek megjeleníthető adatok
    </div>

    <div v-else class="">

      <div v-for="(item, index) in result.content"
           :key="`${item.apNumber}-${item.datePeriod}-${index}`"
           class="item-wrapper mb-3">
        
        <div class="item-card" @click="toggleExpanded(`${item.apNumber}-${item.datePeriod}-${index}`)">
          <!-- Row 1: Cash Register Number + Source Icons -->
          <div class="card-row row-header">
            <div class="cash-register-number font-weight-bold">
              <span class="text-truncate">{{ item.apNumber }}</span>
            </div>
          </div>

          <!-- Row 2: Amounts -->
          <div class="card-row row-amounts">
            <div class="amount-column total-amount-column">
              <div class="label text-muted">Összes forgalom</div>
              <div class="amount-value font-weight-bold">{{ formatAmount(getIdoszakiOsszesForgalom(item)) }}</div>
            </div>
            <div class="amount-column rolled-amount-column">
              <div class="label text-muted">Göngyölített forgalom</div>
              <div class="amount-value font-weight-bold">{{ formatAmount(getGongyolitettForgalom(item)) }}</div>
            </div>
          </div>

          <!-- Row 3: Period -->
          <div class="card-row row-period">
            <div class="period-column">
              <div class="label text-muted">Időszak</div>
              <div class="period-value font-weight-bold">{{ formatDate(item.datePeriod) }}</div>
            </div>
          </div>

          <!-- Row 4: Action Buttons -->
          <div class="card-row row-actions">
            <div class="actions-wrapper">
              <!-- Show hasDifference warning only when navDetails is null and dpDetails exists -->
              <button
                  v-if="shouldShowDifferenceWarning(item)"
                  class="action-btn warning-btn"
                  @click.stop
                  aria-label="Eltérés van"
                  title="Eltérés van a NAV és DP adatok között">
                <i class="fa-solid fa-exclamation"></i>
              </button>
              <div
                  class="d-inline-block text-center pt-2"
                  style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px; cursor: pointer;"
                  :class="item.hasNavSource ? 'bgGreen' : 'bgRed'"
                  @click.stop>
                <button v-b-popover.html.top.click="navPopoverContent" class="btn btn-transparent p-0 m-0" @click.stop>
                  <i class="fal fa-link"></i>
                </button>
              </div>
              <div
                  class="d-inline-block text-center pt-2"
                  style="font-size: 18px; border-radius: 50%; padding: 6px; width: 40px; height: 40px; cursor: pointer;"
                  :class="item.hasDpSource ? 'bgGreen' : 'bgRed'"
                  @click.stop>
                <button v-b-popover.html.top.click="dpPopoverContent" class="btn btn-transparent p-0 m-0" @click.stop>
                  <i class="fal fa-upload"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Expandable VAT Categories Section -->
        <transition name="expand-slide">
          <div v-show="isExpanded(`${item.apNumber}-${item.datePeriod}-${index}`)" class="vat-categories-section">
            <!-- Display details based on priority: overrideDetails > navDetails > dpDetails -->
            <template v-if="getDisplayDetails(item)">
              <div class="vat-categories-row">
                <span class="vat-item">A: <strong>{{ formatAmount(getDisplayDetails(item).details.gross.a) }}</strong></span>
                <span class="vat-item">B: <strong>{{ formatAmount(getDisplayDetails(item).details.gross.b) }}</strong></span>
                <span class="vat-item">C: <strong>{{ formatAmount(getDisplayDetails(item).details.gross.c) }}</strong></span>
                <span class="vat-item">D: <strong>{{ formatAmount(getDisplayDetails(item).details.gross.d) }}</strong></span>
                <span class="vat-item">E: <strong>{{ formatAmount(getDisplayDetails(item).details.gross.e) }}</strong></span>
              </div>
            </template>
            <!-- No details available -->
            <div v-else class="no-details">
              Nincsenek részletes adatok
            </div>
          </div>
        </transition>
      </div>
    </div>

    <paging
        v-if="result.totalNumberOfElements > 0"
        :item-per-page="result.pageSize"
        :total-rows="result.totalNumberOfElements"
        @paging-change="doPage"
    />

  </div>
</template>

<style scoped>
.main-wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Item Wrapper */
.item-wrapper {
  margin-left: 12px;
  margin-right: 12px;
}

/* Card Base Styles */
.item-card {
  background-color: #AEC0C7;
  border-radius: 36px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
}

/* Card Rows */
.card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Row 1: Header - Cash Register Number */
.row-header {
  margin-bottom: 12px;
}

.cash-register-number {
  font-size: 16px;
  color: #333;
}

/* Row 2: Amounts */
.row-amounts {
  margin-bottom: 12px;
  display: flex;
  gap: 24px;
}

.amount-column {
  flex: 1;
}

.amount-column .label {
  font-size: 11px;
  margin-bottom: 2px;
}

.amount-value {
  font-size: 16px;
  color: #333;
}

/* Row 3: Period */
.row-period {
  margin-bottom: 12px;
}

.period-column .label {
  font-size: 11px;
  margin-bottom: 2px;
}

.period-value {
  font-size: 13px;
  color: #333;
}

/* Row 4: Actions */
.row-actions {
  justify-content: flex-end;
  align-items: center;
}

.actions-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
}

.warning-btn {
  background-color: #FFD700;
  color: #333;
}

.unlink-btn {
  background-color: #FF6B6B;
  color: white;
}

.unlink-btn.active {
  background-color: #4CAF50;
}

.upload-btn {
  background-color: #4CAF50;
  color: white;
}

.action-btn:hover {
  transform: scale(1.1);
}

/* Source Badges */
.source-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
  vertical-align: middle;
}

.nav-badge {
  background-color: #007bff;
  color: white;
}

.dp-badge {
  background-color: #28a745;
  color: white;
}

/* VAT Categories Section */
.vat-categories-section {
  background-color: white;
  border-radius: 36px;
  margin-top: 12px;
  margin-bottom: 44px;
  padding: 16px 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
}

.vat-source-block {
  margin-bottom: 8px;
}

.source-title {
  font-size: 12px;
  font-weight: bold;
  color: #555;
  margin-bottom: 4px;
}

.vat-categories-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
}

.vat-item {
  font-size: 13px;
  color: #666;
}

.vat-item strong {
  color: #333;
}

.no-details {
  font-size: 13px;
  color: #999;
  font-style: italic;
}

/* Expand Transition */
.expand-slide-enter-active, .expand-slide-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.expand-slide-enter, .expand-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-slide-enter-to, .expand-slide-leave {
  max-height: 100px;
  opacity: 1;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
}

.bgGreen {
  background-color: #B2EC5D !important;
}

.bgRed {
  background-color: #F88278 !important;
}

.popover {
  max-width: 350px !important;
  width: 450px !important;
  border-radius: 32px !important;
  padding: 14px;
}

/* Desktop Styles (992px and up) */
@media (min-width: 992px) {
  .item-card {
    background-color: #AEC0C7;
    border-radius: 36px;
    padding: 12px 24px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .card-row {
    display: contents;
  }

  .row-header {
    flex: 0 0 auto;
    width: 20%;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  .cash-register-number {
    font-size: 14px;
  }

  .row-amounts {
    flex: 0 0 auto;
    width: 30%;
    display: flex;
    margin-bottom: 0;
    gap: 16px;
  }

  .amount-value {
    font-size: 14px;
  }

  .row-period {
    flex: 0 0 auto;
    width: 20%;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  .row-actions {
    flex: 0 0 auto;
    width: 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
  }

  .vat-categories-section {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 44px;
  }

  .vat-categories-row {
    gap: 24px;
    padding-left: 24px;
  }
}
</style>
